<div class="modal-body d-flex flex-column align-items-center p-3 gap-3 rounded rounded-4">

  <div class="d-flex align-items-center justify-content-center position-relative w-100">
    <img src="assets/icons/icon-72x72.png" class="rounded rounded-3 shadow" [style.width.px]="72" [style.height.px]="72" >
    <button class="position-absolute top-50 end-0 translate-middle-y btn-close" (click)="dismiss()"></button>
  </div>

  <div class="h4">Install Tolaria.app</div>

  <span>For the best experience, install Tolaria.app to on your device.</span>
  
  <ng-container *ngIf="!showInstructions">
    <div class="mt-5 d-flex align-items-center justify-content-center flex-column gap-2 w-100">
      <button type="button" class="btn btn-primary w-50" (click)="install()">Install</button>
      <button type="button" class="btn btn-blank" (click)="dismiss()">Maybe Later</button>
    </div>
  </ng-container>

</div>

<div class="modal-footer d-flex flex-row justify-content-center" *ngIf="showInstructions">
  Tap <img src="assets/ios-share-icon.png" [style.width.rem]="2" [style.marginBottom.rem]="0.75"> then "Add to Home Screen"
</div>